import type {EagGridState} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

const selectVirtualPresetPinned = (state: EagGridState) => state.isVirtualPresetPinned;

export const useVirtualPresetPinned = () => useEagGridSelector(selectVirtualPresetPinned);
